export default __webpack_public_path__ + "static/media/GDPR.b582a793.svg";